import React, {Fragment, useState, useRef, useEffect} from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import EmailIcon from '@material-ui/icons/Email';
import PhoneIcon from '@material-ui/icons/Phone';
import NoteIcon from '@material-ui/icons/Note';
import AssignmentIcon from '@material-ui/icons/Assignment';
import EventIcon from '@material-ui/icons/Event';
import PersonIcon from '@material-ui/icons/Person';
import Tooltip from '@material-ui/core/Tooltip';
import TrackChangesIcon from '@material-ui/icons/TrackChanges';
import MeetingIcon from '@material-ui/icons/Event';
import DealIcon from '@material-ui/icons/MonetizationOn';
import { Field} from 'react-final-form';
import {Select, MultipleSelect, Popup, Chip_input, Explanation_text} from '../../../../../components'
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import {connect} from 'react-redux';


const useStyles = makeStyles((theme) => ({
  primary:{backgroundColor:theme.palette.primary.main},
  secondary:{backgroundColor:theme.palette.secondary.main},
  tertiary:{color:theme.palette.tertiary.main},
}));





function Scorecard(props){
  let score_card=undefined; if(props.scorecards!=undefined && props.me.scorecard_id!=null && props.scorecards[props.me.scorecard_id]!=undefined){score_card=props.scorecards[props.me.scorecard_id];}
  //score_card={data:[{type:'PHONE_CALLS', quantity:7, target:50}, {type:'EMAILS', quantity:15, target:60}, {type:'TASKS_OVERDUE', quantity:53, target:60}]};

  function getIcon(type){
    if(type=='PHONE_CALLS_OUTGOING'){return(<PhoneIcon style={{color:'green'}}/>);}
    else if(type=='PHONE_CALL_ATTEMPTS'){return(<PhoneIcon style={{color:'orange'}}/>);}
    else if(type=='DEALS_OPENED'){return(<DealIcon style={{color:'green'}}/>);}
    else if(type=='OPPORTUNITIES_OPENED'){return(<DealIcon style={{color:'orange'}}/>);}
    else if(type=='EMAILS_SENT'){return(<EmailIcon color='primary'/>);}
    else if(type=='TASKS_COMPLETED'){return(<AssignmentIcon style={{color:'green'}}/>);}
    else if(type=='NEW_PROSPECTS'){return(<PersonIcon color='secondary'/>);}
    else if(type=='MEETINGS_BOOKED'){return(<MeetingIcon color='primary'/>);}
    else if(type=='day_target'){return(<TrackChangesIcon color='primary'/>)}
  }

  function getTitle(scd){
    let t=scd.quantity;
    if(scd.type=='PHONE_CALLS_OUTGOING'){t+=' phone calls connected.';}
    else if(scd.type=='PHONE_CALL_ATTEMPTS'){t+=' phone calls attempted.';}
    else if(scd.type=='DEALS_OPENED'){t+=' deals opened.';}
    else if(scd.type=='OPPORTUNITIES_OPENED'){t+=' opportunities opened.';}
    else if(scd.type=='EMAILS_SENT'){t+=' emails sent.';}
    else if(scd.type=='TASKS_COMPLETED'){t+=' tasks completed.';}
    else if(scd.type=='NEW_PROSPECTS'){t+=' new prospects.';}
    else if(scd.type=='MEETINGS_BOOKED'){t+=' meetings booked.';}
    return t+' Daily target: '+scd.target
  }


  useEffect(()=>{
    if(props.scorecards==undefined){props.index_scorecards();}
  },[]);


  let point_quantity=0;
  let point_target=0;
  if(score_card!=undefined){
    for(let st of score_card.scorecard_trackers){
      point_quantity+=Math.ceil((100*st.quantity)/st.target);
      point_target+=100;
    }
  }
  let month_names=['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  let today=new Date(); today=month_names[today.getMonth()]+' '+(today.getDate());

  return(
    <div id='pv_wiz_3' style={{position:'absolute', bottom:'0px', width:'calc(100% - 2px)', zIndex:'10000', boxShadow:"4px 8px 5px 10px #888888"}}>
    <Grid container style={{backgroundColor:'white', height:'100%', paddingTop:'10px', paddingBottom:'10px', position:'relative'}}>
    <span style={{position:'absolute', left:'5px', top:'2px'}}>{(props.task_mode==true)?<Tooltip title='Switch to tasks view'><AssignmentIcon color='primary' style={{cursor:'pointer'}} onClick={()=>{props.setBottomBar('tasks')}}/></Tooltip>:<Tooltip title='Switch to data entry mode'><Typography color='primary' variant='caption' style={{cursor:'pointer'}} onClick={()=>{props.setBottomBar('decisions')}}>ABC</Typography></Tooltip>}</span>
    <Grid item xs={1} style={{width:'100%', display:'flex', justifyContent:'center', alignItems:'center', marginTop:'-12px', marginBottom:'-10px', paddingLeft:'40px'}}><ArrowBackIcon style={{cursor:'pointer', zIndex:'10000'}} color='primary'  fontSize='small' onClick={()=>{props.submit(true);}} /></Grid>
    <Grid item xs={10} style={{marginTop:'-10px', marginBottom:'-5px',textAlign:'center'}}><span><Typography>{'My scorecard: '+today}</Typography></span></Grid>
    <Grid item xs={1} style={{width:'100%', display:'flex', justifyContent:'center', alignItems:'center', marginTop:'-12px', marginBottom:'-10px'}}><ArrowForwardIcon style={{cursor:'pointer', zIndex:'10000'}} color='primary' fontSize='small'  onClick={()=>{props.submit()}}/></Grid>
    <Grid item xs={12}><hr style={{width:'100%'}}/></Grid>
    <Grid item xs={(score_card==undefined || score_card.total_percentage!=true)?12:10}>
    <Grid container>
    {(score_card==undefined)?<div style={{height:'50px'}}/>:score_card.scorecard_trackers.map(function(scd){
      return (<Tooltip title={getTitle(scd)}><Grid item xs={Math.floor(12/score_card.scorecard_trackers.length)} style={{display:'flex', justifyContent:'center', alignItems:'center', cursor:'pointer', height:'40px'}}><Fragment><span>{getIcon(scd.type)}</span><span style={{marginLeft:'10px', paddingBottom:'2px'}}><Typography>{Math.ceil((100*scd.quantity)/scd.target)}%</Typography></span></Fragment></Grid></Tooltip>)
    })}
    </Grid>
    </Grid>
    {(score_card==undefined || score_card.total_percentage!=true)?null:<Tooltip title={'Daily target'}><Grid item xs={2} style={{display:'flex', justifyContent:'center', alignItems:'center', cursor:'pointer', height:'60px', marginTop:'-10px', marginBottom:'-10px', borderWidth:'0px', borderStyle:'solid', borderLeftWidth:'1px', borderColor:'grey'}}><span>{getIcon('day_target')}</span><span style={{marginLeft:'10px', paddingBottom:'2px'}}><Typography>{(point_target==0)?0:Math.ceil((100*point_quantity)/point_target)}%</Typography></span></Grid></Tooltip>}
    </Grid>
    </div>
  )
}





export default connect(ss, dd)(Scorecard);


function ss(state){
  return{
    scorecards:state.analytics.scorecards,
    refresh:state.analytics.refresh
  }
}

function dd(dispatch){
  return{
    index_scorecards:()=>{dispatch({type:'REQUEST_INDEX_SCORECARDS'})}
  }
}
